import { Container, Sprite, Graphics } from 'pixi.js';
import { AssetLoader } from './AssetLoader';
import { HitboxDefinition, ObstacleHitboxes } from './config/HitboxConfig';

export class PoopObstacle extends Container {
  private sprite: Sprite;
  private obstacleWidth: number;
  private obstacleHeight: number;
  private hitboxConfig: HitboxDefinition;
  private hasBeenHit: boolean = false;
  private stinkParticles: Array<{
    graphics: Graphics;
    offsetX: number;
    offsetY: number;
    age: number;
    maxAge: number;
    driftSpeed: number;
  }> = [];
  private particleSpawnTimer = 0;
  private particleSpawnInterval = 0.3;

  constructor(x: number, y: number, scale: number = 0.3) {
    super();

    const assetLoader = AssetLoader.getInstance();
    const texture = assetLoader.getTexture('obstacle_poop');

    this.sprite = new Sprite(texture);
    this.sprite.anchor.set(0.5, 1);
    this.sprite.scale.set(scale);

    this.obstacleWidth = this.sprite.width;
    this.obstacleHeight = this.sprite.height;
    this.hitboxConfig = ObstacleHitboxes['poop'] || {
      offsetX: 0.1,
      offsetY: 0.1,
      width: 0.8,
      height: 0.8,
    };

    this.x = x;
    this.y = y;

    this.addChild(this.sprite);
    this.createInitialStinkParticles();
  }

  private createInitialStinkParticles(): void {
    // Create a few initial particles for immediate effect
    for (let i = 0; i < 3; i++) {
      this.spawnStinkParticle();
    }
  }

  private spawnStinkParticle(): void {
    const particle = new Graphics();
    const size = 3 + Math.random() * 4; // Random size between 3-7

    particle.circle(0, 0, size);
    particle.fill({ color: 0x88ff44, alpha: 0.6 });

    const offsetX = (Math.random() - 0.5) * 20; // Spread horizontally
    const offsetY = -30 - Math.random() * 10; // Start close above the poop

    particle.x = offsetX;
    particle.y = offsetY;

    this.addChild(particle);

    this.stinkParticles.push({
      graphics: particle,
      offsetX,
      offsetY,
      age: 0,
      maxAge: 1.0 + Math.random() * 0.5, // Live for 1.0-1.5 seconds
      driftSpeed: 15 + Math.random() * 10, // Rise speed (slower)
    });
  }

  update(scrollSpeed: number, deltaTime: number): void {
    this.x -= scrollSpeed * deltaTime;

    // Spawn new stink particles periodically
    this.particleSpawnTimer += deltaTime;
    if (this.particleSpawnTimer >= this.particleSpawnInterval) {
      this.particleSpawnTimer = 0;
      this.spawnStinkParticle();
    }

    // Update existing particles
    for (let i = this.stinkParticles.length - 1; i >= 0; i--) {
      const particle = this.stinkParticles[i];
      particle.age += deltaTime;

      // Float upward with some drift
      particle.offsetY -= particle.driftSpeed * deltaTime;
      particle.offsetX += Math.sin(particle.age * 3) * 10 * deltaTime; // Wavy motion

      particle.graphics.y = particle.offsetY;
      particle.graphics.x = particle.offsetX;

      // Fade out as it ages
      const fadeProgress = particle.age / particle.maxAge;
      particle.graphics.alpha = 0.6 * (1 - fadeProgress);

      // Remove old particles
      if (particle.age >= particle.maxAge) {
        this.removeChild(particle.graphics);
        this.stinkParticles.splice(i, 1);
      }
    }
  }

  isOffScreen(): boolean {
    return this.x + this.obstacleWidth / 2 < 0;
  }

  getHitbox(): { x: number; y: number; width: number; height: number } {
    const hitboxWidth = this.obstacleWidth * this.hitboxConfig.width;
    const hitboxHeight = this.obstacleHeight * this.hitboxConfig.height;
    const hitboxOffsetX = this.obstacleWidth * this.hitboxConfig.offsetX;
    const hitboxOffsetY = this.obstacleHeight * this.hitboxConfig.offsetY;

    return {
      x: this.x - this.obstacleWidth / 2 + hitboxOffsetX,
      y: this.y - this.obstacleHeight + hitboxOffsetY,
      width: hitboxWidth,
      height: hitboxHeight,
    };
  }

  isPoopObstacle(): boolean {
    return true;
  }

  markAsHit(): void {
    this.hasBeenHit = true;
  }

  getHasBeenHit(): boolean {
    return this.hasBeenHit;
  }
}
